import { api } from "@/builders/axios";

const get = function (id: number) {
  return api.get<{
    title: string;
  }>(`courses/module/chapter/content/${id}`);
};

const put = function (id: number, data: { title: string }) {
  return api.put(`/courses/module/chapter/content/${id}`, data);
};

const del = function (id: number) {
  return api.delete(`/courses/module/chapter/content/${id}`);
};

export const id = {
  get,
  put,
  del,
};
